// StyledComponents.js
import { styled } from "@mui/material/styles";
import { Box, Typography, Button, Divider } from "@mui/material";
import { getColor } from "../color/color";
import { fonts } from "../fonts/fonts";

// Styled Container
export const StyledContainer = styled(Box)(({ theme }) => ({
  height: "100vh",
}));

// Styled Question Typography
export const StyledQuestionTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: 700,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  marginLeft: theme.spacing("30px"),
}));

// Styled Button
export const StyledButton = styled(Button)(({ theme, active }) => ({
  width: "100px",
  marginBottom: theme.spacing(2),
  borderRadius: 10,
  padding: theme.spacing(1),
  backgroundColor: active
    ? getColor.SecondaryMidnightBlue
    : getColor.ExtendedPalettesSummerSkySS100,
  color: active ? getColor.PrimaryWhite : getColor.SecondaryMidnightBlue,
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: active ? "800" : "500",
  textTransform: "initial",
}));

// Styled Divider
export const StyledDivider = styled(Divider)(({ theme }) => ({
  color: getColor.Platinum,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  marginLeft: theme.spacing(2),
  width: "90%",
}));

// Styled ACR Button
export const StyledACRButton = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "25%",
}));
